import { z } from 'zod';

export const ClientSchema = z.object({
  id: z.string(),
  name: z.string(),
  fullName: z.string().optional(),
  email: z.string().email(),
  phone: z.string(),
  cpf: z.string().optional(),
  rg: z.string().optional(),
  birthDate: z.string().optional(),
  nationality: z.string().optional(),
  stateOrigin: z.string().optional(),
  cityOrigin: z.string().optional(),
  address: z.union([
    z.string(),
    z.object({
      street: z.string(),
      city: z.string(),
      state: z.string(),
      zipCode: z.string(),
    })
  ]).optional(),
  reducedMobility: z.boolean().optional(),
  mobilityType: z.string().optional(),
  dietaryRestrictions: z.array(z.string()).optional(),
  otherRestriction: z.string().optional(),
  medications: z.string().optional(),
  fishingPreferences: z.object({
    experience: z.enum(['beginner', 'intermediate', 'advanced']),
    targetSpecies: z.array(z.string()),
    equipment: z.string(),
  }).optional(),
  previousGuidesIds: z.array(z.string()).optional(),
  recommendedGuideId: z.string().optional(),
  recommendedGuideName: z.string().optional(),
  createdAt: z.coerce.date().or(z.string()), // Allow string if type says Date | string
  updatedAt: z.coerce.date(), // Strict Date required by type
  notes: z.union([
    z.string(),
    z.object({
        generalNotes: z.string().optional(),
        suggestedNextVisit: z.string().optional()
    })
  ]).optional(),
  tags: z.array(z.string()).optional(),
  type: z.enum(['cliente', 'prospect', 'lead']).optional(),
  isGroupLeader: z.boolean().optional(),
  fishingTripsIds: z.array(z.string()).optional(),
  origin: z.string().optional(),
  importBatchId: z.string().optional(),
}).passthrough(); // Allow extra properties for forward compatibility

export type Client = z.infer<typeof ClientSchema>;
